<template>

<v-dialog v-model="dialog" width="400px">
  <v-card>
    <p class=".title ma-2">Move Guest payment to another booking</p>
    <v-form ref="mvHklrPayment" v-model="mvHklrPaymentValid1">

      <br />
      <p class="mx-2">     
       <v-select v-model="hklr_nr" required :items="hklr_nrKeuzes" item-value="hklr_nr" item-text="hklr_oms" label="Payment" dense :rules="hklr_nrRules"></v-select>
      </p>     
     
      <p class="mx-2">
          <v-text-field v-model="hklr_bedrag" required label="Amount to move" :prefix=hklr.valu_code type="number" :rules="hklr_bedragRules"></v-text-field>
      </p>
    
      <p class="mx-2">
          <v-text-field v-model="huov_code_moveto" required label="Booking ID where the payment moves to" :rules="huov_code_movetoRules"></v-text-field>
      </p>    
       
      <p v-if="hklr.huov_moveto_huis_code > ''" class="mx-2">
          
      Accommodation: {{hklr.huov_moveto_huis_code}} <br />
      Arrival: {{hklr.huov_moveto_vandat}} Departure: {{hklr.huov_moveto_tmdat}}<br />
      Guest: {{hklr.huov_moveto_klnt}} 
      </p>
      
      


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="hklr.huov_moveto_huis_code > ''" class="primary mx-2" small @click="mvHklrPayment" :disabled="!mvHklrPaymentValid1">Move payment</v-btn>
      <v-btn class="primary mx-2" small @click="mvHklrPaymentCheck" :disabled="!mvHklrPaymentValid1">Check this data</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      mvHklrPaymentValid1: false,
      huov_encrid: null,
      hklr_nr: '',
      hklr_bedrag: null,
      huov_code_moveto: null,
      hklr_nrKeuzes: [],
      hklr: {},
      hklr_nrRules: [
          v => (v && v.length >= 1) || "An code is required"
      ],
      huov_code_movetoRules: [
          v => (v && v.length >= 1) || "A booking ID is required"
      ],  
      hklr_bedragRules: [
          v => (v && v.length >= 1) || "An amount is required"
      ]    
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.hklr_nrKeuzes.length = 0;
      this.hklr_dt = '';
      this.hklr_bedrag = '';
      this.hklr_nr = '';
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklrToMvHklrPayment.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHklrToMvHklrPayment"
          },
          getHklrToMvHklrPayment: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hklr = res.data.getHklrToMvHklrPayment;
            res.data.getHklrToMvHklrPayment.hklr_nrKeuzes.forEach(function(hklr) {
                deze.hklr_nrKeuzes.push(hklr); 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mvHklrPaymentCheck() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/mvHklrPaymentCheck.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHklrPaymentCheck"
          },
          mvHklrPaymentCheck: {
            huov_encrid: this.huov_encrid,
            hklr_nr: this.hklr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hklr_bedrag: parseFloat(this.hklr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
               this.hklr = res.data.mvHklrPaymentCheck;  
              if (res.data.mvHklrPaymentCheck.color == "error") {
                  this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.mvHklrPaymentCheck.text,
                        color: res.data.mvHklrPaymentCheck.color
                  }); 
              }  
          }
        })
    },
    mvHklrPayment() { 
      this.$axios
        .post("ares/json/ares/huov/hklr/mvHklrPayment.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHklrPayment"
          },
          mvHklrPayment: {
            huov_encrid: this.huov_encrid,
            hklr_nr: this.hklr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hklr_bedrag: parseFloat(this.hklr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.mvHklrPayment.text,
              color: res.data.mvHklrPayment.color
            }); 
             if (res.data.mvHklrPayment.color == "success" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.mvHklrPayment.huov_encrid); }, 1000); 
            }   
             
            this.dialog = false;
          }
        })
    },
  }
}
</script>

